export const CheckIfRootDomain = (domain) => {
  const rootDomain = process.env.REACT_APP_ROOT_DOMAIN;
  if (
    domain === "wwww" ||
    domain === rootDomain ||
    window.location.hostname === rootDomain
  ) {
    return true;
  }
  return false;
};

export const AddQueryParam = (url, key, value) => {
  let urlObj = new URL(url);
  let params = new URLSearchParams(urlObj.search);

  // Check if there are existing query parameters
  let hasParams = params.toString().length > 0;

  // Add the new parameter
  params.set(key, value);

  // Update the URL
  urlObj.search = params.toString();

  return { updatedUrl: urlObj.toString(), hasParams };
};

export function GetMilestonePreviewUrl(learningObject, payload) {
  if (!learningObject?.contentType || !learningObject?.type) return null;

  const typeToPathMap = {
    Pdf: "pdf",
    Video: "video",
    Scorm: "scorm",
    HTML: "html",
  };

  const folder = typeToPathMap[learningObject.type];

  if (!folder) return null;

  const encodedDetails = btoa(JSON.stringify(payload));
  return `${folder}/player.html?details=${encodedDetails}`;
}
